'use client';
import { Box, Typography } from '@mui/material';
import { Fragment, type ReactNode } from 'react';

interface Props {
  loading: boolean;
  page: number;
  children?: ReactNode; // children for loading state
  additionalMessage?: string;
  op?: boolean;
}

const NoResults = ({ loading, page, children, additionalMessage }: Props) =>
  !loading ? (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        justifyContent: 'center',
        height: '50vh',
      }}
    >
      {page > 100 ? (
        <Fragment key="refine-search">
          <Typography>Please refine your search</Typography>
        </Fragment>
      ) : (
        <Fragment key="no-results">
          <Typography variant="h6">No results found</Typography>
          {additionalMessage && <Typography variant="subtitle1">{additionalMessage}</Typography>}
        </Fragment>
      )}
    </Box>
  ) : (
    <Fragment>{children}</Fragment>
  );

export default NoResults;
